/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Integrate_Api_Keys_CtaInputs */

const en_directory_integrate_api_keys_cta = /** @type {(inputs: Directory_Integrate_Api_Keys_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open API keys`)
};

const zh_directory_integrate_api_keys_cta = /** @type {(inputs: Directory_Integrate_Api_Keys_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开 API 密钥`)
};

/**
* | output |
* | --- |
* | "Open API keys" |
*
* @param {Directory_Integrate_Api_Keys_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_integrate_api_keys_cta = /** @type {((inputs?: Directory_Integrate_Api_Keys_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Integrate_Api_Keys_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_integrate_api_keys_cta(inputs)
	return zh_directory_integrate_api_keys_cta(inputs)
});
export { directory_integrate_api_keys_cta as "directory.integrate.api_keys.cta" }